module.exports = __webpack_public_path__ + "static/media/picture-(264).56d9ee52.JPG";